<template>
    <div style="background-color:#FFF">
        <div class="md-layout" v-if="loaded">
            <div class="md-layout-item md-small-size-100 md-size-100 text-center">
                <h3 class="order-title" style="padding-top: 20px">វិក័យប័ត្រ ONE & ME EXPRESS<br>
                    <h5>086828252 / 0889202999</h5>
                </h3>
            </div>
            <div class="md-layout-item md-small-size-50 md-size-50">
                <h4 class="order-title" style="padding: 0px 0;margin-left:0px; text-align: left;">ព័ត៌មានអតិថិជន</h4>
                <table style="margin-left: 0px">
                    <tr>
                        <td>លេខកូដ</td>
                        <td class="dot">៖</td>
                        <td>{{client.client_hash_id}}</td>
                    </tr>
                    <tr>
                        <td>ឈ្មោះ</td>
                        <td class="dot">៖</td>
                        <td>{{client.client_name}}</td>
                    </tr>
                    <tr>
                        <td>លេខទូរស័ព្ទ</td>
                        <td class="dot">៖</td>
                        <td>{{client.client_phone}}</td>
                    </tr>
                </table>
            </div>
            <div class="md-layout-item md-small-size-50 md-size-50">
                <h4 class="order-title" style="padding: 0px 0;margin-left:0px; text-align: left;">ព័ត៌មានការទូទាត់</h4>
                <table style="margin-left: 0px">
                    <tr>
                        <td>តម្លៃឥវ៉ាន់សរុប</td>
                        <td class="dot">៖</td>
                        <td><b>{{config.moneylify(payment.total_usd, 'usd')}} + {{config.moneylify(payment.total_khr, 'khr')}}</b></td>
                    </tr>
                    <tr>
                        <td>សេវាដឹកជញ្ជូនសរុប</td>
                        <td class="dot">៖</td>
                        <td><b>{{config.moneylify(payment.total_fee_usd, 'usd')}} + {{config.moneylify(payment.total_fee_khr, 'khr')}}</b></td>
                    </tr>
                    <tr>
                        <td>ទឹកប្រាក់បានទូទាត់</td>
                        <td class="dot">៖</td>
                        <td><b>{{config.moneylify(payment.total_usd - payment.total_fee_usd, 'usd')}} + {{config.moneylify(payment.total_khr - payment.total_fee_khr, 'khr')}}</b></td>
                    </tr>
                    <tr>
                        <td>កាលបរិច្ឆេទទូទាត់</td>
                        <td class="dot">៖</td>
                        <td><b>{{config.datelify(payment.created_date)}}</b></td>
                    </tr>
                </table>
            </div>

            <div class="md-layout-item md-small-size-100 md-size-100">
                <md-table v-if="packageList.length > 0" style="margin-top: 30px;">
                    <md-table-row class="no-hover">
                        <md-table-cell class="small-size">លេខកូដ</md-table-cell>
                        <md-table-cell class="small-size">ប្រភេទ និងទីតាំង</md-table-cell>
                        <md-table-cell class="small-size">អ្នកទទួល</md-table-cell>
                        <md-table-cell class="small-size">តម្លៃឥវ៉ាន់</md-table-cell>
                        <md-table-cell class="small-size">ថ្លៃដឹកជញ្ជូន</md-table-cell>
                        <md-table-cell class="small-size">ស្ថានភាព</md-table-cell>
                    </md-table-row>

                    <md-table-row class="no-hover" v-for="(pkg, index) in packageList">
                        <md-table-cell class="small-size no-hover">​{{ index + 1 }}, <b>{{ pkg.tracking
                                }}</b><br>{{config.datelify(pkg.created_date)}}
                        </md-table-cell>
                        <md-table-cell class="small-size no-hover"><b>{{ pkg.location }}</b><br>{{ pkg.package_type }}
                        </md-table-cell>
                        <md-table-cell class="small-size no-hover">{{ pkg.receiver_phone }}</md-table-cell>
                        <md-table-cell class="small-size no-hover">
                            <span v-if="pkg.status == 'dlv'">
                                <b>{{ config.moneylify(pkg.price, pkg.price_currency) }}</b>
                                <br>
                                <span v-if="pkg.price == 0">(ទូទាត់ជាមួយអ្នកផ្ញើផ្ទាល់)</span>
                                <!-- <span v-else>(មិនទាន់ទូទាត់)</span> -->
                            </span>
                            <span v-else><b>-----</b><br>({{ config.moneylify(pkg.price, pkg.price_currency)
                                }})</span>
                        </md-table-cell>
                        <md-table-cell class="no-hover small-size">
                            <span v-if="pkg.status == 'dlv'">
                                <b>{{ config.moneylify(pkg.fee, pkg.fee_currency) }} </b>
                                <br>
                                <span> ({{config.getStatus(pkg.fee_responsible)}}អ្នកបង់)</span>
                            </span>
                            <span v-else-if="String(pkg.note).length > 0">{{pkg.note}}</span>
                            <!-- <span v-else>មិនមាន</span> -->
                            <span v-else><b>-----</b><br>({{ config.moneylify(pkg.fee, pkg.fee_currency) }})</span>
                        </md-table-cell>
                        <md-table-cell class="no-hover small-size">
                            <span class="error" v-if="pkg.status == 'ndv'">{{ config.getStatus(pkg.status) }}</span>
                            <span class="late" v-if="pkg.status == 'wdv'">{{ config.getStatus(pkg.status) }}</span>
                            <span class="neutral" v-if="pkg.status == 'dvr'">{{ config.getStatus(pkg.status) }}</span>
                            <span class="green" v-if="pkg.status == 'dlv'">{{ config.getStatus(pkg.status) }}</span>
                            <span class="return" v-if="pkg.status == 'rtn'">{{ config.getStatus(pkg.status) }}</span>
                        </md-table-cell>
                    </md-table-row>
                    <md-table-row class="no-hover">
                        <md-table-cell>​</md-table-cell>
                        <md-table-cell></md-table-cell>
                        <md-table-cell style="text-align: right;"><b>សរុប:</b></md-table-cell>
                        <md-table-cell><b>{{config.moneylify(payment.total_usd, 'usd')}} + {{config.moneylify(payment.total_khr, 'khr')}}</b></md-table-cell>
                        <md-table-cell><b>{{config.moneylify(payment.total_fee_usd, 'usd')}} + {{config.moneylify(payment.total_fee_khr, 'khr')}}</b></md-table-cell>
                        <md-table-cell></md-table-cell>
                    </md-table-row>
                    <md-table-row class="no-hover">
                        <md-table-cell>​</md-table-cell>
                        <md-table-cell></md-table-cell>
                        <md-table-cell style="text-align: right;"><b>ទឹកប្រាក់ត្រូវទូទាត់:</b></md-table-cell>
                        <md-table-cell colspan="2" style="text-align: center;"><b>{{config.moneylify(payment.total_usd - payment.total_fee_usd, 'usd')}} + {{config.moneylify(payment.total_khr - payment.total_fee_khr, 'khr')}}</b></md-table-cell>
                        <md-table-cell></md-table-cell>
                    </md-table-row>
                </md-table>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        created() {
            this.searchPayment();
        },
        mounted() {
        },
        data() {
            return {
                loaded: false,
                packageList: [],
                client: {
                    client_hash_id: "",
                    client_name: "",
                    client_phone: "",
                    client_note: ""
                },
                payment: {
                    total_fee_khr: 0,
                    total_fee_usd: 0,
                    total_khr: 0,
                    total_usd: 0,
                    created_date: 0
                }
            }
        },
        methods: {
            searchPayment() {
                this.$http.post(this.config.api + "/admin/transaction/get/client_package", {
                    hash_id: this.$route.params.hash_id
                }).then(data_list => {
                    this.$http.get(this.config.api + "/admin/transaction/get/" + this.$route.params.hash_id).then(data_info => {

                        if (data_list.body.data.length > 0) {
                            let packageList = data_list.body.data[0].packageList
                            let delivered = [];
                            let delivering = [];
                            let waiting = [];
                            let returned = [];
                            let other = [];
                            for (let i = 0; i < packageList.length; i++) {
                                switch (packageList[i].status) {
                                    case "dlv":
                                        delivered.push(packageList[i]);
                                        break;
                                    case "dvr":
                                        delivering.push(packageList[i]);
                                        break;
                                    case "rtn":
                                        returned.push(packageList[i]);
                                        break;
                                    case "wdv":
                                        waiting.push(packageList[i]);
                                        break;
                                    default:
                                    case "wdv":
                                        other.push(packageList[i]);
                                        break;
                                }
                            }
                            this.client.client_hash_id = data_list.body.data[0].client_hash_id;
                            this.client.client_name = data_list.body.data[0].client_name;
                            this.client.client_phone = data_list.body.data[0].client_phone;

                            this.payment.total_fee_khr = data_list.body.data[0].total_fee_khr;
                            this.payment.total_fee_usd = data_list.body.data[0].total_fee_usd;
                            this.payment.total_khr = data_list.body.data[0].total_khr;
                            this.payment.total_usd = data_list.body.data[0].total_usd;
                            this.payment.created_date = data_info.body.data[0].created_date
                            this.packageList = delivered.concat(delivering, waiting, other, returned);
                            let d = new Date();
                            // document.title = `${this.client.client_hash_id}-${this.client.client_name}-${d.getDate()}-${d.getMonth() + 1}-${d.getFullYear()}`
                            this.loaded = true;
                            // setTimeout(() => {

                            // 	window.print();
                            // }, 1000)
                        }
                    })
                })
            }
        }
    }
</script>

<style>
    /* @media print {
        body {
            page: a4;
        }
    } */

    .small-size {
        font-size: 10px !important;
    }

    .dot {
        padding: 0 30px;
    }

    .no-hover:hover {
        background-color: #FFF !important;
    }

    body {
        background-color: #FFF !important;
    }

    .print-logo {
        height: 100px !important;
        margin: 16px;
    }

    .order-title {
        margin-top: 0;
        margin-bottom: 0;
    }

    .product-thumbnail {
        width: 64px;
        height: 64px;
        margin-right: 13px;
    }
</style>


// WEBPACK FOOTER //
// src/pages/PrintPaymentClient.vue